import { FETCH_INVOICING_LOG_REQUEST, FETCH_INVOICING_LOG_SUCCESS, FETCH_INVOICING_LOG_FAILURE, FETCH_INVOICING_LOG_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const invoicingLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_INVOICING_LOG_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_INVOICING_LOG_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_INVOICING_LOG_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case FETCH_INVOICING_LOG_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default invoicingLogReducer;
